// ===============================
//  BASE COUPON DEFINITIONS (po kodu)
// ===============================

// HOME / GUEST – main: PINATA45
export const COUPON_PINATA45 = {
    title: "Welcome Free Chip",
    bonus: "$50 Free Chip",
    mco: "$50",
    minDeposit: "None",
    wagering: "30x",
    maxBet: "None",
    maxBonus: "None",
    games: "NP Slots, Keno, Plinko, Video Poker",
    available: ["For new players", "1x per player"],
    code: "GOATSTART",
    infoText: "Welcome Bonus - $50 Free Chip",
    ctaHref: "/promotions",
    mainValue: "$50",
};

// NON-DEPOSITOR free bonus nova verzija
export const COUPON_NEWYEARGOAT = {
    title: "NEWYEARGOAT",
    bonus: "20 Free Spins",
    mco: "$30",
    minDeposit: "None",
    wagering: "x30",
    maxBet: "$10",
    maxBonus: "$30",
    games: "NP Slots Only",
    available: ["1x per day until 31.12.2025"],
    code: "NEWYEARGOAT",
    infoText: "20FS Goat Non-Depositors",
    ctaHref: "/promotions",
    mainValue: "20FS",
};


// BRONZE TAIL / SILVER main
export const COUPON_10NEWYEAR = {
    title: "10NEWYEAR",
    bonus: "10 Free Chip",
    mco: "$50",
    minDeposit: "None",
    wagering: "x30",
    maxBet: "$10",
    maxBonus: "$50",
    games: "NP Slots Only",
    available: ["1x per day until 31.12.2025"],
    code: "10NEWYEAR",
    infoText: "10FC GOAT BronzeTail/CC/Silver",
    ctaHref: "/promotions",
    mainValue: "$10",
};

// VIP BRONZE TAIL / TRANSFERRED main
export const COUPON_20NEWYEAR = {
    title: "20NEWYEAR",
    bonus: "20 Free Chip",
    mco: "$100",
    minDeposit: "None",
    wagering: "x30",
    maxBet: "$10",
    maxBonus: "$100",
    games: "NP Slots Only",
    available: ["1x per day until 31.12.2025"],
    code: "20NEWYEAR",
    infoText: "20FC GOAT VIP Bronze Tail",
    ctaHref: "/promotions",
    mainValue: "$20",
};

// ===============================
//  WELCOME / DEPOSIT BONUSES (tabs)
// ===============================
//rebuild
//rebuild
// GOATMODE – Welcome bonus (up to 900%)
export const COUPON_GOATMODE = {
    title: "GOATMODE",
    bonus: "Up to 900%",
    mco: "50x Deposit",
    minDeposit: "$25",
    wagering: "30x (Deposit + Bonus)",
    maxBet: "$5",
    maxBonus: "", // nije definisan, ostavljamo prazno
    games: "NP Slots Only",
    available: ["On first deposit"],
    code: "GOATMODE",
    infoText:
        "Bonus structure: $10 - 400%, $25 - 500%, $50 - 900%. Max cashout 50x deposit.",
    ctaHref: "/promotions",
};

// LIMITLESS – no-rule stil
export const COUPON_LIMITLESS = {
    title: "LIMITLESS",
    bonus: "111% Boost",
    mco: "None",
    minDeposit: "$25",
    wagering: "x1 Deposit + Bonus",
    maxBet: "$10",
    maxBonus: "$200",
    games: "NP Slots Only",
    available: ["1x per player"],
    code: "LIMITLESS",
    infoText: "111% Conversion Boost",
    ctaHref: "/promotions",
};

// GOATPLAY – low wager
export const COUPON_GOATPLAY = {
    title: "GOATPLAY",
    bonus: "101%",
    mco: "None",
    minDeposit: "$35",
    wagering: "15x Deposit + Bonus",
    maxBet: "$5",
    maxBonus: "$500",
    games: "Slots, Keno & Plinko",
    available: ["1x per Day, 5x Weekly"],
    code: "GOATPLAY",
    infoText: "101% Low wager boost",
    ctaHref: "/promotions",
};

// 100% Cashback on First Deposit (generalni cashback kupоn)
export const COUPON_FIRSTDEPOSIT_CASHBACK = {
    title: "100% Cashback on First Deposit",
    bonus: "100% Cashback",
    mco: "x5",
    minDeposit: "", // možeš posle precizirati
    wagering: "x30",
    maxBet: "$10",
    maxBonus: "",
    games: "Non-progressive Slots",
    available: ["After First Deposit"],
    code: "CASHBACK100", // ako je kod drugačiji, samo promeni
    infoText: "100% cashback bonus on first deposit (terms may apply).",
    ctaHref: "/promotions",
};

// ===============================
//  BOOST / VIP BONUSES (GOATBOOST, GOATS, KRAKEN)
// ===============================

export const COUPON_GOATBOOST = {
    title: "GOATBOOST",
    bonus: "105% / 155% / 255%",
    mco: "None",
    minDeposit: "$30 / $50 / $75",
    wagering: "40x (Deposit + Bonus)",
    maxBet: "$2",
    maxBonus: "$500",
    games: "Only Non-Progressive Slots",
    available: ["1x per day"],
    code: "GOATBOOST",
    infoText: "Daily boost for all players",
    ctaHref: "/promotions",
};

export const COUPON_GOATS = {
    title: "GOATNIGHT",
    bonus: "69% Low Wager Bonus",
    mco: "None",
    minDeposit: "30 USDT",
    wagering: "x20 (Deposit + Bonus)",
    maxBet: "5 USDT",
    maxBonus: "1000 USDT",
    games: "Non-progressive slots, Keno, Video Poker",
    available: ["Available: 3x per day, from 00:00 - 6:00 EST"],
    code: "GOATNIGHT",
    infoText:
        "GOAT of all bonuses.",
    ctaHref: "/promotions",
};

export const COUPON_KRAKEN = {
    title: "KRAKEN",
    bonus: "100%",
    mco: "None",
    minDeposit: "$100",
    wagering: "15x Deposit + Bonus",
    maxBet: "$5",
    maxBonus: "$500",
    games: "Non-progressive slots",
    available: ["1x per day, 3 per week"],
    code: "KRAKEN",
    infoText:
        "100% low wager bonus + 50% cashback for lost deposits attached to this coupon.",
    ctaHref: "/promotions",
};

// ===============================
//  LEGACY-LIKE CONSTANTS (po “principu” koji si slao)
//  – lakše ti je da dalje menjaš komponente
// ===============================

// HOME PAGE (svi vide, user nije ulogovan)
export const COUPON_MAIN_DEFAULT = COUPON_PINATA45;

export const COUPON_BONUS1_DEFAULT = COUPON_GOATMODE;                  // Welcome bonus 1tab
export const COUPON_BONUS2_DEFAULT = COUPON_LIMITLESS;                 // No rule 2tab
export const COUPON_BONUS3_DEFAULT = COUPON_GOATPLAY;                 // Low wager 3tab
export const COUPON_BONUS4_DEFAULT = COUPON_FIRSTDEPOSIT_CASHBACK;     // 100% cb on first dep

// NON-DEP klasa (ulogovan user, class = non-depositor)
export const COUPON_MAIN_NONDEP = COUPON_NEWYEARGOAT;
// Tabs za non-dep su isti kao za home (GOATMODE, LIMITLESS, GOATPLAY , 100% CB),
// pa ne moramo praviti nove konstante – u UI ih samo mapiraš na ove iste objekte.

// BRONZE TAIL / BRONZE TAIL SILVER (Optimist klasa)
export const COUPON_MAIN_OPTIMIST = COUPON_10NEWYEAR;
// 1tab: GOATBOOST
export const COUPON_BONUS1_OPTIMIST = COUPON_GOATBOOST;
// 2tab: GOATPLAY 
export const COUPON_BONUS2_OPTIMIST = COUPON_GOATPLAY;
// 3tab: GOATS
export const COUPON_BONUS3_OPTIMIST = COUPON_GOATS;
// 4tab: KRAKEN
export const COUPON_BONUS4_OPTIMIST = COUPON_KRAKEN;

// VIP BRONZE TAIL / VIP - TRANSFERRED (Elite klasa)
export const COUPON_MAIN_ELITE = COUPON_20NEWYEAR;
// 1tab: GOATPLAY
export const COUPON_BONUS1_ELITE = COUPON_GOATPLAY;
// 2tab: KRAKEN
export const COUPON_BONUS2_ELITE = COUPON_KRAKEN;
// 3tab: GOATBOOST
export const COUPON_BONUS3_ELITE = COUPON_GOATBOOST;
// 4tab: GOATS
export const COUPON_BONUS4_ELITE = COUPON_GOATS;
